import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-doctor2_stock",
  "use": "icon-doctor2_stock-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-doctor2_stock\">\r\n  <path d=\"M1024 423.765333h-102.485333V938.666667h-161.834667v-384.896H264.32V938.666667H102.485333V423.765333H0L512 85.333333l512 338.432z m-187.818667-21.888L512 187.605333 187.818667 401.92v66.56h648.362666v-66.56z\" fill=\"#fff\" p-id=\"6295\" data-spm-anchor-id=\"a313x.search_index.0.i0.51873a81So1K9n\" class=\"selected\" />\r\n  <path d=\"M661.504 618.666667H362.453333V725.333333h299.008v-106.666666zM661.504 832H362.453333V938.666667h299.008v-106.666667z\" fill=\"#fff\" p-id=\"6296\" data-spm-anchor-id=\"a313x.search_index.0.i1.51873a81So1K9n\" class=\"selected\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/doctor2_stock.svg
// module id = QEnA
// module chunks = 10